import { BaseFetch } from "../main-model"
export default class DesiredCharacteristicsModel extends BaseFetch {
  getDesiredCharacteristicsBy = (data) =>
    this.authFetch({
      url: "desired-characteristics/getDesiredCharacteristicsBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getDesiredCharacteristicsById = (data) =>
    this.authFetch({
      url: "desired-characteristics/getDesiredCharacteristicsById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateDesiredCharacteristicsById = (data) =>
    this.authFetch({
      url: "desired-characteristics/updateDesiredCharacteristicsById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertDesiredCharacteristics = (data) =>
    this.authFetch({
      url: "desired-characteristics/insertDesiredCharacteristics",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteDesiredCharacteristicsById = (data) =>
    this.authFetch({
      url: "desired-characteristics/deleteDesiredCharacteristicsById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
